module.exports = __webpack_public_path__ + "static/img/user2.282b2150.png";